export const COIN_GLYPH = '◉';

export function formatMoney(value: number): string {
  return Math.round(value).toLocaleString('en-US');
}

export function formatPercent(rate: number, dp = 1): string {
  return `${(rate * 100).toFixed(dp)}%`;
}

export function formatYears(years: number): string {
  return Number.isInteger(years) ? `${years}` : years.toFixed(1);
}
